import React, { Component } from 'react'
import { Spinner, DialogSeletor } from 'scorpion-core';
import { Button, Typography, Divider } from '@material-ui/core';
import View from 'react-flexbox'
import ItemRelatorio from '../ItemRelatorio';
import BotaoEnviaJson from '../BotaoEnviaJson';


export default class PainelEmiteRelatorio extends Component {
    componentDidMount() {
        this.props.listarRelatoriosUser();
    }

    show = () => {
        this.dialogRelatorioInterno.show()
        const { relatorios, dados, meta, tipoModelo } = this.props
        console.log('tipoModelo', tipoModelo);
        console.log('JsonDados', dados);
    };

    hide = () => {
        this.dialogRelatorioInterno.hide()
    };

    enviarParaDeveloper() {
        const { dados, tipoModelo } = this.props;
        let meta = {}

        this.props.setJsonGerarOkReportDeveloper(dados, meta)
        let rota = "/OkReportDeveloperForm"
        if (tipoModelo) {
            this.props.history.push({
                pathname: rota,
                state: { tipoModelo }
            })
        } else {
            this.props.history.push(rota)
        }
    }

    render() {
        const { relatorios, dados, meta, tipoModelo } = this.props


        return (
            <DialogSeletor innerRef={node => this.dialogRelatorioInterno = node}>
                <View column style={{ width: 500, height: 400 }}>
                    <div style={{ backgroundColor: '#007559', textAlign: 'center', padding: 10 }}>
                        <Typography variant="h5" style={{ color: "#fff" }}>
                            Relatórios
                    </Typography>
                    </div>
                    {this.props.loading_form ? <Spinner /> :
                        <View column style={{ padding: 10, overflow: "auto", justifyContent: 'flex-start', }}>
                            {relatorios.map((r, index) => <ItemRelatorio key={index} r={r} index={index} dados={dados} meta={meta} actionclose={this.hide} />)}
                        </View>
                    }
                    <Divider />
                    <Button variant="contained" color="primary" style={{ margin: 10 }} onClick={() => this.hide()} >Cancelar</Button>

                    <BotaoEnviaJson texto="Elaborar Relatório" tipoModelo={tipoModelo} dados={dados} meta={meta} />

                </View>
            </DialogSeletor>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/PainelEmiteRelatorio/PainelEmiteRelatorio.js